import React, { useState } from "react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import Modal from "@/components/Modal"
import SkeletonTable from "@/components/SkeletonTable"
import { Checkbox } from "@/components/ui/checkbox"
import api from "@/lib/axios"
import { DataPendaftaran, RuangCbtDetail } from "@/types"
import { MoreHorizontal } from "lucide-react"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { Link } from "react-router-dom"
import Form from "./Form"
import toast from "react-hot-toast"
import { AxiosError } from "axios"

const getListPesertaRuang = async (id_ref_ruang_cbt_detail: string) => {
  const response = await api.get(
    `/setting/ruang-cbt-detail/detail-peserta?id_ref_ruang_cbt_detail=${id_ref_ruang_cbt_detail}`
  )
  return response.data?.data
}

type PatchDataStatusKehadiranParams = {
  id_data_distribusi_ruangan: string
  is_status_hadir: boolean | number
}

export const patchDataStatusKehadiran = async ({
  id_data_distribusi_ruangan,
  is_status_hadir,
}: PatchDataStatusKehadiranParams) => {
  const response = await api.patch(
    "/setting/ruang-cbt-detail/set-hadir-wawancara-talent",
    {
      id_data_distribusi_ruangan,
      is_status_hadir,
    }
  )

  return response.data
}
export default function Actions({ row }: { row: RuangCbtDetail }) {
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [showPeserta, setShowPeserta] = useState(false)
  const [selectedRow, setSelectedRow] = useState<RuangCbtDetail | null>(null)

  const queryClient = useQueryClient()
  const { mutate } = useMutation({
    mutationFn: patchDataStatusKehadiran,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listPesertaRuang"] })
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const { data: listPesertaRuang, isPending: isPendingListPesertaRuang } =
    useQuery({
      queryFn: () => getListPesertaRuang(row.id_ref_ruang_cbt_detail),
      queryKey: ["listPesertaRuang", showPeserta],
      enabled: showPeserta && !!row.id_ref_ruang_cbt_detail,
    })

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowEdit(true)
                setSelectedRow(row)
              }}
            >
              Edit
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            {/* <DropdownMenuItem
              onClick={() => {
                setShowDelete(true);
                setSelectedRow(row);
              }}
            >
              Delete
            </DropdownMenuItem> */}
            <DropdownMenuItem
              onClick={() => {
                setShowPeserta(true)
                setSelectedRow(row)
              }}
            >
              Lihat Peserta
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <Modal show={showEdit} onClose={() => setShowEdit(false)}>
        <Form
          closeModal={() => setShowEdit(false)}
          selectedRow={selectedRow}
          method="PATCH"
        />
      </Modal>
      <Modal show={showDelete} onClose={() => setShowDelete(false)}>
        <Form
          closeModal={() => setShowDelete(false)}
          selectedRow={selectedRow}
          method="DELETE"
        />
      </Modal>
      <Modal
        show={showPeserta}
        onClose={() => setShowPeserta(false)}
        className="lg:w-[64vw] w-[95vw]"
      >
        <div>
          {isPendingListPesertaRuang ? (
            <SkeletonTable />
          ) : (
            <table className="table-auto w-full border-collapse border rounded-xl overflow-hidden">
              <thead>
                <tr>
                  <th className="px-2 py-1 font-semibold border">No</th>
                  <th className="px-2 py-1 font-semibold border">
                    Nomor Pendaftaran
                  </th>
                  <th className="px-2 py-1 font-semibold border">Nama</th>
                  <th className="px-2 py-1 font-semibold border">
                    Nomor Handphone
                  </th>
                  <th className="px-2 py-1 font-semibold border">
                    Jenis Kelamin
                  </th>
                  <th className="px-2 py-1 font-semibold border">
                    Status Kehadiran
                  </th>
                </tr>
              </thead>
              <tbody>
                {listPesertaRuang && listPesertaRuang?.length > 0 ? (
                  listPesertaRuang?.map(
                    (
                      item: {
                        id_data_distribusi_ruangan: string
                        is_hadir_wawancara_talent: boolean | number | null
                        data_pendaftaran: DataPendaftaran
                      },
                      index: number
                    ) => {
                      return (
                        <tr>
                          <td className="px-2 py-1 border text-center">
                            {index + 1}
                          </td>
                          <td className="px-2 py-1 border">
                            {item.data_pendaftaran?.nomor_pendaftaran}
                          </td>
                          <td className="px-2 py-1 border">
                            {item.data_pendaftaran?.data_siswa?.nama_lengkap}
                          </td>
                          <td className="px-2 py-1 border">
                            <div className="flex justify-end gap-3">
                              {item.data_pendaftaran?.data_siswa?.handphone}
                              <Link
                                to={`https://wa.me/${item.data_pendaftaran?.data_siswa?.handphone?.replace(
                                  /^0/,
                                  "62"
                                )}`}
                                target="_blank"
                                className="ml-3"
                              >
                                <Button variant={"outline"} size={"icon"}>
                                  <img
                                    src="https://static.cdnlogo.com/logos/w/43/whatsapp.svg"
                                    alt="Whatsapp"
                                    width={30}
                                    height={30}
                                    className="mx-auto"
                                  />
                                </Button>
                              </Link>
                            </div>
                          </td>
                          <td className="px-2 py-1 border text-center">
                            {item.data_pendaftaran?.data_siswa?.jenis_kelamin}
                          </td>
                          <td className="px-2 py-1 border text-center">
                            <div className="flex justify-center gap-3">
                              <div>
                                <Checkbox
                                  checked={item.is_hadir_wawancara_talent == 1}
                                  onCheckedChange={() => {
                                    mutate({
                                      id_data_distribusi_ruangan:
                                        item.id_data_distribusi_ruangan,
                                      is_status_hadir: 1,
                                    })
                                  }}
                                />
                                <p>Hadir</p>
                              </div>
                              <div>
                                <Checkbox
                                  checked={item.is_hadir_wawancara_talent == 0}
                                  onCheckedChange={() => {
                                    mutate({
                                      id_data_distribusi_ruangan:
                                        item.id_data_distribusi_ruangan,
                                      is_status_hadir: 0,
                                    })
                                  }}
                                />
                                <p>Tidak Hadir</p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )
                    }
                  )
                ) : (
                  <tr>
                    <td className="px-2 py-1 border" colSpan={5}>
                      Data tidak ditemukan
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </Modal>
    </React.Fragment>
  )
}
